import React from "react";
import HeroBackground from "../../assets/images/IZB/IZB Website Skin/Home_Page/New_changes/Untitled-1.png";
import MobileStoreButton from "react-mobile-store-button";
import "./Hero.css";
import { Link } from "react-router-dom";


import BankingMenu from "./BankingMenu";

const HeroSlide1 = () => {
const bannerPhones = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Group 1000003036.png";
const Logo = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Group 402.png";
const Logo1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/Group 403.png";



  // const HeroBgimg = {
  //   height: "75vh",
  //   backgroundRepeat: "no-repeat",
  //   backgroundSize: "100%",
  //   overflow: "hidden",
  // };

  const iosUrl =
    "https://apps.apple.com/in/app/izb-retail-banking/id1507943733";
  const androidUrl =
    "https://play.google.com/store/apps/details?id=com.izb&hl=en&gl=US";
  return (
    <div className="HeroSlider1">
      <div className="container sliderContent h-100 position-absolute premier-banking-absolute-content">
        <div className="position-absolute">
          <div className="h-75 position-relative">
            <div className="d-flex">
              <div className="pt-4 col-12 col-md-4 col-lg-4 bannerPhone">
                <img src={bannerPhones} width={350} alt="" />
              </div>
              <div className="flex-wrap align-self-xl-center ms-4 col-12">
                <h2
                  className="py-1 AccOpen"
                  style={{ color: "#9E1B1E"}}
                >
                  Account Opening
                </h2>
                <h1
                  className="py-1"
                  style={{ color: "#ECAA44", fontSize: "54px" }}
                >
                  Made Easy!
                </h1>
                <p className="pb-4" style={{ fontWeight: "600" }}>
                  Open and <span style={{ color: "#9E1B1E" }}> INDO EEZY </span>{" "}
                  savings Account on your Phone.
                </p>
                <div className="d-flex align-items-center">
                
                    <Link to={androidUrl} target="_blank" >
                      <img src={Logo} width={150} style={{textDecoration:"none", border:"none"}} />
                    </Link>
                      <Link to={iosUrl} target="_blank">
                      <img src={Logo1} width={150} />
                    </Link>
                </div>
                <div className="pt-4 col-12 col-md-4 col-lg-4 AfterText">
                <img src={bannerPhones} width={350} alt="" />
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/Slider1.png" alt="hero-banner-desktop" className="hide-on-mobile home-hero-banner" />
      <img src="https://izbassetsmain.blob.core.windows.net/izbwebassets/ITB Mobile Banner-01.jpg" alt="hero-banner-mobile" className="hide-on-desktop home-hero-banner" />
    </div>
  );
};

export default HeroSlide1;
